module.exports = __webpack_public_path__ + "img/GooglePlay-right.22364ba6.png";